
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/flows/[id]",
      function () {
        return require("private-next-pages/flows/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/flows/[id]"])
      });
    }
  